module.exports = __webpack_public_path__ + "static/media/close.a1a57c06.svg";